<template>
  <div class="product">
    <el-row>
      <el-col :span="6">
        <div class="vue-padding" style="margin-right: 10px; height: 749px; border-radius: 10px">
          <el-form :model="couponsForm" :rules="rules" ref="couponsForm">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.couponname')" prop="name">
                  <el-input v-model="couponsForm.name" :placeholder="$t('product.couponnamehold')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item
                  :label="$t('product.manjianjine')"
                  prop="reachPrice"
                  v-if="couponsForm.mode != '3' && couponsForm.mode != 3"
                >
                  <el-input v-model="couponsForm.reachPrice" type="number" :placeholder="$t('product.manjianjinehold')">
                  </el-input>
                  <span style="color: red">{{ $t("product.manjianjineds") }}</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.youhuileixing')" prop="mode">
                  <el-select
                    v-model="couponsForm.mode"
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    filterable
                    :placeholder="$t('product.youhuileixinghold')"
                  >
                    <el-option
                      v-for="item in couponsmode"
                      :key="item.id"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="!couponsForm.mode" :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.youhuijine')" prop="price">
                  <el-input
                    v-model="couponsForm.price"
                    type="number"
                    :placeholder="$t('product.youhuijinehold')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="couponsForm.mode === '1' || couponsForm.mode === 1" :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.youhuijine')" prop="price">
                  <el-input
                    v-model="couponsForm.price"
                    type="number"
                    :placeholder="$t('product.youhuijinehold')"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="couponsForm.mode === '2' || couponsForm.mode === 2" :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.zhekoubaifenbi')" prop="price">
                  <el-input
                    max="100"
                    v-model="couponsForm.price"
                    type="number"
                    :placeholder="$t('product.zhekoubaifenbihold')"
                  ></el-input>
                  <el-input-number max="100" v-model="couponsForm.price" style="display: none" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="couponsForm.mode === '3' || couponsForm.mode === 3" :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.quanhoujia')" prop="price">
                  <el-input v-model="couponsForm.price" type="number" :placeholder="$t('product.quanhoujiahold')">
                    <template slot="append">{{ $t("product.yuan") }}</template>
                  </el-input>
                  <div class="quanhoujia-tips">
                    <span>{{ $t("product.quanhoujiaTips") }}</span>
                  </div>
                  <div class="quanhoujia-example">
                    <i class="el-icon-info"></i>
                    <span>{{ $t("product.quanhoujiaExample") }}</span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.youxiaoshichang')" prop="exTime">
                  <el-date-picker
                    v-model="couponsForm.exTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :placeholder="$t('product.youxiaoshichanghold')"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item :label="$t('product.fafangshuliang')" prop="num">
                  <el-input v-model="couponsForm.num" type="number" :placeholder="$t('product.fafangshulianghold')">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item>
                  <el-button type="primary" @click="submitForm('couponsForm')" style="margin-top: 20px">{{
                    $t("common.add")
                  }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="el-search vue-top-padding">
          <div class="el-left" style="margin: 0">
            <el-button
              size="small"
              v-hasPerm="['user:coupons:export']"
              icon="el-icon-receiving"
              @click="exportCoupons"
              style="margin: 0"
              >{{ $t("common.export") }}</el-button
            >
          </div>
          <div class="el-right">
            <el-form ref="product" :model="search" :inline="true" size="small" class="demo-form-inline el-input-height">
              <el-form-item prop="name" style="margin: 0 10px 0 0">
                <el-input v-model="search.name" :placeholder="$t('product.couponname')"></el-input>
              </el-form-item>
              <el-form-item style="margin: 0">
                <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t("common.search") }}</el-button>
                <el-button @click="resetSearch()" icon="el-icon-refresh">{{ $t("common.reset") }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="vue-padding">
          <el-table
            v-loading="loading"
            :empty-text="$t('common.noData')"
            :element-loading-text="$t('common.loading')"
            :data="productList"
            style="width: 100%"
            max-height="638"
            :border="true"
          >
            <el-table-column
              prop="name"
              :label="$t('product.couponname')"
              min-width="200"
              :align="'center'"
            ></el-table-column>
            <el-table-column
              prop="reachPrice"
              :align="'center'"
              width="150"
              :label="$t('product.manjianjine')"
            ></el-table-column>
            <el-table-column
              prop="mode"
              :align="'center'"
              width="160"
              :label="$t('product.youhuileixing')"
              :formatter="funcmode"
            ></el-table-column>
            <el-table-column
              prop="price"
              :align="'center'"
              width="140"
              :label="$t('product.youhuijine')"
            ></el-table-column>
            <el-table-column
              prop="createTime"
              :align="'center'"
              width="160"
              :label="$t('product.createTime')"
            ></el-table-column>
            <el-table-column
              prop="exTime"
              :align="'center'"
              width="160"
              :label="$t('product.expireDate')"
            ></el-table-column>
            <el-table-column
              prop="num"
              :align="'center'"
              width="140"
              :label="$t('product.fafangshuliang')"
            ></el-table-column>
            <el-table-column
              prop="overNum"
              :align="'center'"
              width="170"
              :label="$t('product.overNum')"
            ></el-table-column>
            <el-table-column
              fixed="right"
              :label="$t('common.operate')"
              :width="$i18n.locale == 'zh_CN' ? 170 : 202"
              :align="'center'"
            >
              <template slot-scope="scope">
                <el-button size="mini" @click="showCouponCode(scope.row)">{{ $t("product.lookcode") }}</el-button>
                <el-button size="mini" type="danger" @click="delCoupon(scope.row)">{{ $t("common.delete") }}</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            v-if="productList.length > 0"
            background
            layout="prev, pager, next"
            :current-page="page.pageIndex"
            :total="page.totalSize"
            :page-size="page.pageSize"
            @current-change="currentChange"
          ></el-pagination>
        </div>
      </el-col>
    </el-row>
    <!-- 查看券码 -->
    <el-drawer
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="showTitle"
      :visible.sync="showTable"
      direction="rtl"
      size="30%"
    >
      <el-row>
        <el-col span="24">
          <el-button
            size="small"
            v-hasPerm="['user:coupons:export']"
            icon="el-icon-receiving"
            @click="exportCouponsMa"
            style="margin-bottom: 3%"
            >{{ $t("common.export") }}</el-button
          >
          <el-table
            v-loading="codeloading"
            :empty-text="$t('common.noData')"
            :element-loading-text="$t('common.loading')"
            :data="codeData"
            style="width: 100%"
          >
            <el-table-column property="code" :label="$t('product.duihuanma')"></el-table-column>
            <el-table-column property="isUse" :label="$t('product.zhuangtai')" :formatter="funcState"></el-table-column>
          </el-table>
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="codepage.pageIndex"
            :total="codepage.totalSize"
            :page-size="codepage.pageSize"
            @current-change="currentChangeCode"
          ></el-pagination>
        </el-col>
      </el-row>
    </el-drawer>
  </div>
</template>

<script>
  export default {
    name: "Coupons",
    components: {},
    data() {
      return {
        search: {
          name: ""
        },
        loading: false,
        page: {
          pageSize: 10,
          pageIndex: 1,
          totalSize: 0
        },
        productList: [],
        couponsForm: {
          name: "",
          reachPrice: "",
          mode: "",
          price: "",
          exTime: "",
          num: ""
        },
        couponsmode: [],
        couponsState: [],
        showTitle: this.$t("product.lookcode"),
        showTable: false,
        codeData: [],
        codeloading: false,
        codepage: {
          pageSize: 10,
          pageIndex: 1,
          totalSize: 0
        },
        codesearch: {
          discountId: 0
        }
      };
    },
    activated() {
      this.couponsForm.name = "";
      this.couponsForm.reachPrice = "";
      this.couponsForm.mode = "";
      this.couponsForm.price = "";
      this.couponsForm.exTime = null;
      this.couponsForm.num = "";
    },
    mounted() {
      this.couponState();
      this.couponmode();
      this.currentChange();
    },
    computed: {
      rules() {
        const priceMessage =
          this.couponsForm.mode === "3" || this.couponsForm.mode === 3
            ? this.$t("product.quanhoujiahold")
            : this.$t("product.youhuijinehold");
        return {
          name: [
            {
              required: true,
              message: this.$t("product.couponnamehold"),
              trigger: "blur"
            }
          ],
          reachPrice: [
            {
              required: true,
              message: this.$t("product.manjianjinehold"),
              trigger: "blur"
            }
          ],
          mode: [
            {
              required: true,
              message: this.$t("product.youhuileixinghold"),
              trigger: "change"
            }
          ],
          price: [
            {
              required: true,
              message: priceMessage,
              trigger: "blur"
            }
          ],
          num: [
            {
              required: true,
              message: this.$t("product.fafangshulianghold"),
              trigger: "blur"
            }
          ],
          exTime: [
            {
              required: true,
              message: this.$t("product.youxiaoshichanghold"),
              trigger: "blur"
            }
          ]
        };
      }
    },
    methods: {
      // 导出优惠券
      exportCoupons() {
        this.$confirm(this.$t("product.export"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            console.log(this.search);
            this.$api.download(this.$url.Product.exportCoupon, this.search);
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      },
      // 导出优惠券码
      exportCouponsMa() {
        this.$confirm(this.$t("product.exportMa"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        })
          .then(() => {
            this.$api.download(this.$url.Product.exportCouponMa, {
              discountId: this.codesearch.discountId
            });
          })
          .catch(err => {
            this.$message.error(err.msg);
          });
      },
      // 获取优惠券状态
      couponState() {
        this.$api.dict("coupon_state").then(res => {
          if (res.code === 0) {
            this.couponsState = res.data;
          }
        });
      },
      // 获取优惠券类型
      couponmode() {
        this.$api.dict("coupon_type").then(res => {
          if (res.code === 0) {
            this.couponsmode = res.data;
          }
        });
      },
      // 格式化优惠券类型
      funcmode(row) {
        return this.$cloud.getDictLabel(this.couponsmode, parseInt(row.mode));
      },
      // 格式化优惠券状态
      funcState(row) {
        /* let newset = {
                    value: parseInt(row.state),
                    label: this.$cloud.getDictLabel(this.couponsState, parseInt(row.state))
                }
                console.log(newset) */
        return this.$cloud.getDictLabel(this.couponsState, parseInt(row.isUse));
      },
      // 提交保存优惠券
      submitForm(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            const couponsForm = {
              ...this.couponsForm,
              reachPrice:
                this.couponsForm.mode === "3" || this.couponsForm.mode === 3 ? 0 : this.couponsForm.reachPrice
            };
            this.$api
              .request(this.$url.Product.insertCoupons, this.$method.post, couponsForm)
              .then(res => {
                if (res.code === 0) {
                  this.$message({
                    message: this.$t("product.addSuccess"),
                    type: "success"
                  });
                  this.currentChange();
                }
              })
              .catch(() => {
                this.$message({
                  message: this.$t("product.addFail"),
                  type: "warning"
                });
              });
          } else {
            console.log("error submit!!");
            return false;
          }
        });
      },
      // 获取优惠券列表
      currentChange(pageIndex) {
        this.loading = true;
        this.page.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.search, this.page);
        this.$api
          .request(this.$url.Product.getCoupons, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.productList = res.data.records;
              this.page.totalSize = parseInt(res.data.total);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },
      // 查询搜索
      onSubmit() {
        console.log(this.search);
        this.currentChange();
      },
      // 重置
      resetSearch() {
        this.search.name = "";
        this.currentChange();
      },
      // 查看券码
      showCouponCode(row) {
        this.codesearch.discountId = row.id;
        this.currentChangeCode();
        this.showTable = true;
      },
      // 获取优惠券券码列表
      currentChangeCode(pageIndex) {
        this.codeloading = true;
        this.codepage.pageIndex = pageIndex ? pageIndex : 1;
        let obj = this.$cloud.objMerge(this.codesearch, this.codepage);
        this.$api
          .request(this.$url.Product.getCouponsCode, this.$method.get, obj)
          .then(res => {
            if (res.code === 0) {
              this.codeData = res.data.records;
              this.codepage.totalSize = parseInt(res.data.total);
            }
            this.codeloading = false;
          })
          .catch(() => {
            this.codeloading = false;
          });
      },
      // 删除优惠券
      delCoupon(row) {
        this.$confirm(this.$t("product.deleteCoupon"), this.$t("common.warning"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api
            .request(this.$url.Product.deleteCoupon, this.$method.delete, {
              id: row.id
            })
            .then(res => {
              if (res.code === 0) {
                this.$notify({
                  title: this.$t("common.tip"),
                  message: res.msg,
                  type: "success"
                });
                this.currentChange(this.page.pageIndex);
              }
            });
        });
      }
    }
  };
</script>

<style>
  .el-tag--mini {
    margin-right: 5px;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .el-drawer__header {
    margin: 0;
    padding: 20px;
  }
  .el-drawer__body {
    padding: 0 10px;
  }
  .quanhoujia-tips {
    color: #606266;
    font-size: 12px;
    margin-top: 8px;
    line-height: 1.5;
  }
  .quanhoujia-tips i {
    color: #409eff;
    margin-right: 5px;
  }
  .quanhoujia-example {
    background-color: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: 4px;
    padding: 8px 12px 8px 32px;
    margin-top: 8px;
    color: #606266;
    font-size: 12px;
    position: relative;
    line-height: 1.5;
  }
  .quanhoujia-example i {
    color: #409eff;
    font-size: 14px;
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
  }
  .quanhoujia-example i {
    color: #409eff;
    margin-right: 8px;
    font-size: 14px;
  }
</style>
